/*
Getways constants FORM API
*/
export const START = 'start_profile';
export const ADD_PROFILE = 'add_profile';
export const SELECT_PROFILE = 'select_profile';
export const ADMIN_PROFILE = 'administration_profile';
export const EDIT_PROFILE = 'edit_profile';
export const COMPLETE_PROFILE = 'complete_profile';
//Constatnts for Metrics
export const METRIC_EVENT = 'event';

export const METRIC_CATEGORY_START = 'Inicio';
export const METRIC_CATEGORY_TOPMENU = 'Top Menú';

export const METRIC_ACTION_PROFILE = 'Perfiles';
export const METRIC_ACTION_ADMINPROFILE = 'Administrar Perfiles';
export const METRIC_ACTION_CLICK = 'Click';

export const METRIC_LABEL_ADD = 'Agregar';
export const METRIC_LABEL_ADMINPROFILE = 'Administrar Perfiles';
export const METRIC_LABEL_CHANGEIMAGE = 'Cambiar Imagen';
export const METRIC_LABEL_SELECTIMAGE = 'Seleccionar imagen';
export const METRIC_LABEL_NEWPROFILESUCCESSFUL = 'Nuevo perfil exitoso';
export const METRIC_LABEL_DELETEPROFILE = 'Eliminar Perfil';
export const METRIC_LABEL_MYPROFILE = 'Mi Perfil';
export const METRIC_LABEL_SETTINGSPROFILE = 'Ajustes de Perfil';
export const METRIC_LABEL_LOGOUT = 'Cerrar Sesión';
export const METRIC_LABEL_PROFILE = 'Perfil';
export const METRIC_LABEL_VIEWPROFILE = 'Ver Perfiles';



// WEBPACK FOOTER //
// ./src/components/Profile/constants.js